import fileExtension from '../../utils/file-extension';
import mimeExtension from './mime-extension';
import isString from './is-string';

export default function sourceExtension (source) {
  if (!source) return '';

  if (isString(source)) {
    return fileExtension(source);
  }

  if (source.type) {
    return mimeExtension(source.type);
  }

  return fileExtension(source.url);
};
